const trimTrailingSlash = (value = "") => String(value || "").replace(/\/+$/, "");

const rawApiUrl = trimTrailingSlash(process.env.REACT_APP_API_URL || "");

const normalizedApiUrl = rawApiUrl
  ? rawApiUrl.endsWith("/api")
    ? rawApiUrl
    : `${rawApiUrl}/api`
  : "/api";

export const APP_CONFIG = {
  apiBaseUrl: normalizedApiUrl,
};

export const apiPath = (path) => {
  const cleanPath = String(path || "")
    .replace(/^\/api\/?/, "")
    .replace(/^\//, "");

  return `/${cleanPath}`;
};

const AUTH_ENDPOINTS = {
  login: apiPath("/auth/login"),
  register: apiPath("/auth/register"),
  confirm: (email) => apiPath(`/auth/confirm?email=${encodeURIComponent(email)}`),
  forgotPassword: apiPath("/auth/forgot-password"),
  resetPassword: (token) => apiPath(`/auth/reset-password/${token}`),
};

const ADMIN_ENDPOINTS = {
  contacto: apiPath("/admin/contacto"),
  users: apiPath("/admin/users"),
  inviteUser: apiPath("/admin/users/invite"),
  updateUser: (id) => apiPath(`/admin/users/update/${id}`),
  deleteUser: (id) => apiPath(`/admin/users/delete/${id}`),
  resendInvitation: (id) => apiPath(`/admin/users/${id}/resend-invitation`),
  updateUserValidation: (id) => apiPath(`/admin/users/${id}/validation`),
  preguntas: apiPath("/admin/preguntas"),
  createPregunta: apiPath("/admin/preguntas/create"),
  updatePregunta: (id) => apiPath(`/admin/preguntas/update/${id}`),
  deletePregunta: (id) => apiPath(`/admin/preguntas/delete/${id}`),
  procesos: apiPath("/admin/procesos"),
  createProceso: apiPath("/admin/procesos/create"),
  updateProceso: (id) => apiPath(`/admin/procesos/update/${id}`),
  deleteProceso: (id) => apiPath(`/admin/procesos/delete/${id}`),
  evaluacionesTrends: apiPath("/admin/evaluaciones/trends"),
  procesosMadurez: apiPath("/admin/procesos/madurez"),
};

const AUTOEVALUACIONES_ENDPOINTS = {
  resumen: (usuarioId) => apiPath(`/autoevaluaciones/resumen/${usuarioId}`),
  crear: apiPath("/autoevaluaciones/crear"),
  obtenerOptimizado: (cuestionarioId) => apiPath(`/autoevaluaciones/obtenerOptimizado/${cuestionarioId}`),
  actualizar: (cuestionarioId) => apiPath(`/autoevaluaciones/actualizar/${cuestionarioId}`),
  guardarProgreso: (cuestionarioId) => apiPath(`/autoevaluaciones/guardarProgreso/${cuestionarioId}`),
  finalizar: (cuestionarioId) => apiPath(`/autoevaluaciones/finalizarCuestionario/${cuestionarioId}`),
  resultados: (cuestionarioId) => apiPath(`/autoevaluaciones/resultados/${cuestionarioId}`),
  resultadosDetallados: (cuestionarioId) => apiPath(`/autoevaluaciones/resultados-detallados/${cuestionarioId}`),
  generarResumenEjecutivo: (cuestionarioId) => apiPath(`/autoevaluaciones/ia/generate-overview/${cuestionarioId}`),
  organizarPorPlazo: (cuestionarioId) => apiPath(`/autoevaluaciones/${cuestionarioId}/organizar-por-plazo`),
  todasLasTareas: (cuestionarioId) => apiPath(`/autoevaluaciones/${cuestionarioId}/all-tasks`),
};

const PROCESOS_ENDPOINTS = {
  porUsuario: (usuarioId) => apiPath(`/procesos/${usuarioId}`),
};

export const API_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  admin: ADMIN_ENDPOINTS,
  autoevaluaciones: AUTOEVALUACIONES_ENDPOINTS,
  procesos: PROCESOS_ENDPOINTS,

  login: AUTH_ENDPOINTS.login,
  register: AUTH_ENDPOINTS.register,
  forgotPassword: AUTH_ENDPOINTS.forgotPassword,
  resetPassword: AUTH_ENDPOINTS.resetPassword,

  adminContacto: ADMIN_ENDPOINTS.contacto,
  adminUsers: ADMIN_ENDPOINTS.users,
  adminInviteUser: ADMIN_ENDPOINTS.inviteUser,
  updateAdminUser: ADMIN_ENDPOINTS.updateUser,
  deleteAdminUser: ADMIN_ENDPOINTS.deleteUser,
  resendInvitation: ADMIN_ENDPOINTS.resendInvitation,
  updateUserValidation: ADMIN_ENDPOINTS.updateUserValidation,
  adminPreguntas: ADMIN_ENDPOINTS.preguntas,
  createPregunta: ADMIN_ENDPOINTS.createPregunta,
  updatePregunta: ADMIN_ENDPOINTS.updatePregunta,
  deletePregunta: ADMIN_ENDPOINTS.deletePregunta,
  adminProcesos: ADMIN_ENDPOINTS.procesos,
  createProceso: ADMIN_ENDPOINTS.createProceso,
  updateProceso: ADMIN_ENDPOINTS.updateProceso,
  deleteProceso: ADMIN_ENDPOINTS.deleteProceso,
  evaluacionesTrends: ADMIN_ENDPOINTS.evaluacionesTrends,
  procesosMadurez: ADMIN_ENDPOINTS.procesosMadurez,

  resumenAutoevaluaciones: AUTOEVALUACIONES_ENDPOINTS.resumen,
  crearAutoevaluacion: AUTOEVALUACIONES_ENDPOINTS.crear,
  obtenerAutoevaluacionOptimizada: AUTOEVALUACIONES_ENDPOINTS.obtenerOptimizado,
  obtenerOptimizado: AUTOEVALUACIONES_ENDPOINTS.obtenerOptimizado,
  actualizarAutoevaluacion: AUTOEVALUACIONES_ENDPOINTS.actualizar,
  guardarProgreso: AUTOEVALUACIONES_ENDPOINTS.guardarProgreso,
  finalizarCuestionario: AUTOEVALUACIONES_ENDPOINTS.finalizar,
  resultados: AUTOEVALUACIONES_ENDPOINTS.resultados,
  resultadosDetallados: AUTOEVALUACIONES_ENDPOINTS.resultadosDetallados,
  generarResumenEjecutivo: AUTOEVALUACIONES_ENDPOINTS.generarResumenEjecutivo,
  generateOverview: AUTOEVALUACIONES_ENDPOINTS.generarResumenEjecutivo,
  organizarPorPlazo: AUTOEVALUACIONES_ENDPOINTS.organizarPorPlazo,
  todasLasTareas: AUTOEVALUACIONES_ENDPOINTS.todasLasTareas,

  procesosByUser: PROCESOS_ENDPOINTS.porUsuario,
  procesosPorUsuario: PROCESOS_ENDPOINTS.porUsuario,
};
